import type { FolderItem } from '@/api/model/folderModel'
import type { BasicResult } from '@/api/model/resultModel'
import type { CartDocumentBox } from '@/views/SendCart/typeData'

/**
 * @description ドキュメント詳細取得 API 引数
 */
export interface QueryDocumentDetailParameters {
  folderID: string
  productID: string
  documentID: string
}

export interface FileItem {
  // 企業 ID
  corporate_id: number
  // ファイル ID
  file_id: number
  // ファイル名
  file_name: string
  // ファイルパス
  file_path: string
  // ファイルサイズ
  file_size: number
  // ファイルアップロード企業 ID
  file_upload_corporate_id: number
  // 登録日
  insert_datetime: string
  // 登録者（姓）
  insert_user_family_name: string
  // 登録者（名）
  insert_user_given_name: string
  // 最新版フラグ
  latest_edtion_flag: string
  // 改訂日
  revision_date: string
  // 更新日時
  update_datetime: string
}

export type FileList = FileItem[]

export interface DocumentItem {
  // 発行元商品コード
  issuer_product_code: string
  // ドキュメント種別
  document_type: string
  // 備考
  remark: string
  // ファイルリスト
  file_list: FileList
}

export type DocumentList = DocumentItem[]

export interface QueryDocumentDetailModel {
  detail: DocumentList
}

//送信先選択
export interface RecipientOption {
  // 企業 ID
  corporate_id: number
  // 送信先 ID
  recipient_id: number
  // 送信先名
  recipient_name: string
  // フォルダ ID
  folder_id: number
  // フォルダ名
  folder_name: string
  // 作成日
  insert_datetime: string
  // 作成者
  insert_user_name: string
  // 更新日
  update_datetime: string
}

/**
 * @description getRecipientOptions Response
 */
export type RecipientOptionList = RecipientOption[]

/**
 * @description  送信先詳細
 */
export interface DestinationDetail {
  // 取引先コード
  client_code: string
  // 取引先名
  client_name: string
  // 法人名
  corporate_name: string
  // 法人名（ソート）
  corporate_name_sort: string
  // 法人番号
  corporate_number: number
  // 部署
  recipient_department_name: string
  // 送信先詳細 ID
  recipient_detail_id: number
  // 送信先 ID
  recipient_id: number
  // メールアドレス
  recipient_mail: string
  // 担当者 ID
  recipient_user_id: number
  // 担当者名
  recipient_user_name: string
}

export type DestinationDetailList = DestinationDetail[]

/**
 * @description queryDestinationDetailList response
 */
export type QueryDestinationDetailListModel = BasicResult<DestinationDetail>

/**
 * @description queryDestinationFolderTree response
 */
export type QueryOtherCompanyProductListByUserModel = BasicResult<FolderItem>

/**
 * @description registSendCartDestination parameters
 */
export interface RegistSendCartDestinationParameters {
  // 送信カート区分
  sender_carts_category: SendCartTypeEnum
  // 送信先法人番号
  recipient_corporate_number: number | string
  // 送信先法人名
  recipient_corporate_name: string
  // 送信先取引先コード
  recipient_client_code: string
  // 送信先取引先名
  recipient_client_name: string
  // 送信先担当者 ID
  recipient_user_id: number
  // 送信先担当者名
  recipient_user_name: string
  // 送信先担当者部署
  recipient_department_name: string
  // 送信先担当者メールアドレス
  recipient_mail: string
  // 送信先企業 ID
  // NOTE: 不要なデータだが、データベースに列があるので無効な値を設定
  recipient_corporate_id: number
  // 送信先フォルダ ID
  recipient_folder_id: number
  // 送信先 ID
  recipient_id: number
}

export interface RecipientDetailsModel {
  current_page: Number
  total_count: Number
  detail: Array<RecipientDetailsItemModel>
}

export interface RecipientDetailsItemModel {
  client_code: string
  client_name: string
  corporate_number: string
  corporate_name: string
  corporate_name_sort: string
  recipient_id: string
  recipient_detail_id: string
  recipient_user_id: string
  recipient_user_name: string
  recipient_mail: string
  recipient_department_name: string
}

export type SendCartDestinationInfo = RegistSendCartDestinationParameters

export interface UpdateRecipientDetailList {
  recipient_id: number
  recipient_detail_id: number | null
  corporate_number: number
  corporate_name: string
  client_code: string
  client_name: string
  delete_flag: number
  recipient_user_list?: UpdateRecipientDetailUserList
}
export interface UpdateRecipientDetailUserItem {
  recipient_user_id: string | null
  recipient_user_name: string
  recipient_department_name: string
  recipient_mail: string
  delete_flag: number
}

export type UpdateRecipientDetailUserList = UpdateRecipientDetailUserItem[]

export interface UpdateRecipientDetailsModel {
  recipient_detail_list: UpdateRecipientDetailList[]
}

// 送信カート区分
export enum SendCartTypeEnum {
  // 通常の送信カート
  NORMAL = '1',
  // 改版送信カート
  REVISION = '0',
}

/** @description 送信カート取得 API 戻り値 */
export interface QuerySendCartResponse {
  /** @description 送信可能かどうか */
  sendable: boolean
  /** @description 送信不可メッセージコード */
  message_code: string
  /** @description 送信不可メッセージ */
  message: string
  /** @description 送信カート詳細 */
  detail: CartDocumentBox[]
}
